// extracted by mini-css-extract-plugin
export default {"navLink":"App_navLink__JICGV"};